import PropTypes from 'prop-types'

import { isBlank } from 'utils'

import Text from 'components/Text'

import { Addresses, Root } from './CustomerAddresses.style'

const CustomerAddresses = ({ addresses }) => {
  return (
    <Root>
      <Addresses>
        {isBlank(addresses) && <Text>No addresses found</Text>}
        {addresses?.map((address) => (
          <div key={address.id}>
            <Text as="div">{address.recipient}</Text>
            <Text as="div">{address.address1}</Text>
            <Text as="div">{address.address2}</Text>
            <Text as="div">{address.city}</Text>
            <Text as="div">{address.state}</Text>
            <Text as="div">{address.country}</Text>
          </div>
        ))}
      </Addresses>
    </Root>
  )
}

CustomerAddresses.propTypes = {
  addresses: PropTypes.array,
}

CustomerAddresses.defaultProps = {}

export default CustomerAddresses
